<div class="d-flex flex-column">
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.requestedPercentage' | translate}}:</div>
    <div>{{proposal.proposalInformation.coveragePercentageRequested + "%"}}</div>
  </div>
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.requestedRolesExpandableDetails' | translate}}:</div>
    <div>
      {{(proposal.proposalInformation.leadInsurerNeeded ?  'createProposal.leader' : '' )  | translate}}
      {{proposal.proposalInformation.leadInsurerNeeded && proposal.proposalInformation.followingInsurerNeeded ?  ', ' : '' }}
      {{(proposal.proposalInformation.followingInsurerNeeded ?  'createProposal.follower' : '' )  | translate}}
    </div>
  </div>
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.lineOfBusiness' | translate}}:</div>
    <div>{{proposal.lineOfBusiness.number ? ('lineOfBusiness.clauses.' + proposal.lineOfBusiness.number + '.name' | translate) : proposal.lineOfBusiness.name}}</div>
  </div>
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.beginDate' | translate}}:</div>
    <div>{{proposal.proposalInformation.riskDateBegin| date : ('dateFormat' | translate)}}</div>
  </div>
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.endDate' | translate}}:</div>
    <div>{{proposal.proposalInformation.riskDateEnd | date : ('dateFormat' | translate)}}</div>
  </div>
  <div *ngIf="proposal.proposalInformation.mainDueDate" class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.mainDueDate' | translate}}:</div>
    <div>{{'createProposal.monthOptions.' + proposal.proposalInformation.mainDueDate | translate}}</div>
  </div>
  <div *ngIf="proposal.proposalInformation.paymentMethod" class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.paymentMethod' | translate}}:</div>
    <div>{{'createProposal.paymentMethodOptions.' + proposal.proposalInformation.paymentMethod | translate}}</div>
  </div>
</div>
